<template>
  <div>
    <div class="row color1">
      <div class="left">
        <Icon type="md-contact" />{{row.consignee}}
      </div>
      <div class="right">
        <Icon type="ios-call" />{{row.consigneeTel}}
      </div>
    </div>
    <div class="row color2">
      <div class="left">
        <Icon type="ios-pin-outline" />{{row.consigneeAddr}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'User',
  components: {},
  props: {
    row: {
      type: Object,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function() {
        return {}
      }
    },
  },
  data() {
    return {
      TagColor: 'yellow'
    }
  },
  computed: {},
  created() {},

  methods: {
    queryInit() {},
  }
}

</script>
<style scoped lang="less">
.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.row .left,
.row .right {
  flex: 1;
  font-size: 13px;
}

.color1 {
  color: rgba(0, 0, 0, 0.65);
}

.color2 {
  color: rgba(0, 0, 0, 0.45);
}

</style>
